"use client";
import React from "react";
import { Caveat } from "next/font/google";
import Image from "next/image";
import { motion } from "framer-motion";

const caveat = Caveat({ subsets: ["latin"], weight: ["400", "700"], display: "swap" });

export default function FitnessPosSection({ section }) {
  const title = section?.title || "Max out on extra sales";
  const mainText = section?.mainText || "<strong className='text-white font-semibold'>Intuitive Point of Sale.</strong> Set up the Point of Sale app for your clients to enjoy a sports drink after a class or to purchase accessories, merch, and class passes.";
  const posImage = section?.posImage || "/odoo/industries/fitness/pos-extra-sales.png";

  return (
    <section className="py-20 lg:py-24 px-6 sm:px-12 lg:px-24 relative overflow-visible bg-transparent font-sans text-white w-full z-10">
      <div className="container mx-auto max-w-[1400px]">

        {/* Section Header with Smiley Face Icon & Highlighted Extra Sales Box */}
        <motion.div  
          initial={{ opacity: 0, y: -20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12 max-w-4xl mx-auto"
        >
          {/* Smiley Icon */}
          <div className="w-14 sm:w-16 h-14 sm:h-16 mx-auto mb-4 text-amber-400">
            <svg viewBox="0 0 64 64" fill="none" className="w-full h-full stroke-current" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="32" cy="32" r="26" className="fill-amber-400/20" strokeWidth="4" />
              <circle cx="22" cy="24" r="3" className="fill-amber-400" />
              <circle cx="42" cy="24" r="3" className="fill-amber-400" />
              <path d="M 20 38 Q 32 50, 44 38" strokeWidth="4" />
            </svg>
          </div>

          {/* Heading with Orange Highlight Box */}
          <h2 className={`text-4xl sm:text-6xl lg:text-7xl font-bold tracking-tight text-white leading-tight mb-6 ${caveat.className}`}>
            <span>Max out on </span>
            <span className="relative inline-block px-3 py-1 text-slate-950 font-bold bg-amber-400 rounded-2xl transform -rotate-1 shadow-lg">
              extra sales
            </span>
          </h2>

          {/* Subtext Description */}
          <p 
            className="text-slate-300 text-lg md:text-xl leading-relaxed font-normal max-w-3xl mx-auto"
            dangerouslySetInnerHTML={{ __html: mainText }}
          />
        </motion.div>

        {/* Direct Image matching user reference screenshot (NO background container) */}
        <motion.div 
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="relative max-w-5xl mx-auto flex justify-center items-center pt-4"
        >
          <Image
            src={posImage}
            alt="Max out on extra sales Point of Sale interface"
            width={964}
            height={470}
            className="w-full h-auto object-contain transition-transform duration-300 hover:scale-[1.01]"
            priority
          />
        </motion.div>

      </div>
    </section>
  );
}
